import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './CommentInfoDrawer.module.css'
import {
  Button,
  ConfigProvider,
  Divider,
  Drawer,
  Input,
  message,
  Modal,
  Rate,
  Space,
} from 'antd'
import classNames from 'classnames'
import {
  deleteCommentRequest,
  getCommentInfoRequest,
  sendCommentRequest,
} from './api'
import Icon, {
  CommentOutlined,
  HeartFilled,
  PlusOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import locale from 'antd/locale/zh_CN'
import CommentItem from './CommentItem'
import { pointer } from '@testing-library/user-event/dist/cjs/pointer/index.js'

export default function CommentInfoDrawer(props) {
  const [zhonghepingjia, setZhonghepingjia] = useState(0)
  const [commentList, setCommentList] = useState([])
  const [zhibiaoList, setZhibiaoList] = useState([])
  const [commentNumber, setCommentNumber] = useState(0)
  const [comment, setComment] = useState('')
  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    if (props.drawerStatus) {
      setComment('')
      // getCommentStandardMethod()
      getCommentInfoMethod(0, 4, 0)
    }
    return () => {
      // console.log('组件即将卸载');
    }
  }, [props.drawerStatus]) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  function getCommentInfoMethod(offset, limit, requestType) {
    // requestType ，0是第一次请求，1加载更多，2是发送消息之后获取的最新一条记录
    // getCommentInfoRequest(props.info.code,(data)=>{
    getCommentInfoRequest(props.info.yingyong_type,props.info.code, offset, limit, (data) => {
      if (requestType == 0) {
        if (data.ret == 1) {
          setZhonghepingjia(data.data.zonghe_pingfen)
          setCommentList(data.data.pingjia_list)
          setCommentNumber(data.data.total_num)
          setZhibiaoList(data.data.pingjia_zhibiao)
        } else {
          setZhonghepingjia(0)
          setCommentList([])
          setCommentNumber(0)
          setZhibiaoList([])
        }
      } else if (requestType == 1) {
        if (data.ret == 1) {
          setZhonghepingjia(data.data.zonghe_pingfen)
          setCommentList(commentList.concat(data.data.pingjia_list))
          setCommentNumber(data.data.total_num)
          setZhibiaoList(data.data.pingjia_zhibiao)
        } else {
          setZhonghepingjia(0)
          setCommentList([])
          setCommentNumber(0)
          setZhibiaoList([])
        }
      } else if (requestType == 2) {
        if (data.ret == 1) {
          setZhonghepingjia(data.data.zonghe_pingfen)
          setCommentList(data.data.pingjia_list.concat(commentList))
          setCommentNumber(data.data.total_num)
          setZhibiaoList(data.data.pingjia_zhibiao)
        } else {
          setZhonghepingjia(0)
          setCommentList([])
          setCommentNumber(0)
          setZhibiaoList([])
        }
      }
    })
  }

  function sendCommentMethod() {
    if (comment.replaceAll(' ', '').length == 0) {
      message.warning('评论不能为空')
    } else if (
      zhibiaoList[0].fenshu == 0 &&
      zhibiaoList[1].fenshu == 0 &&
      zhibiaoList[2].fenshu == 0 &&
      zhibiaoList[3].fenshu == 0
    ) {
      Modal.confirm({
        title: '提示',
        content: '仅发送评论，不进行指标评价？',
        onOk() {
          sendComment()
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    } else {
      sendComment()
    }
  }
  function sendComment(params) {
    sendCommentRequest(
      props.info.yingyong_type,
      props.info.code,
      props.info.title,
      zhibiaoList,
      comment,
      (data) => {
        setComment('')
        if (data.ret == 1) {
          getCommentInfoMethod(0, 1, 2)
          props.refreshMethod()
        } else {
          message.warning(data.msg)
        }
      },
    )
  }

  function deleteCommentMethod(item) {
    Modal.confirm({
      title: '确认删除',
      content: '确定要删除评论“' + item.pingjia_content + '”吗？删除后不可恢复',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        console.log('用户点击了确定')
        // 在这里调用删除API
        deleteCommentRequest(
          props.info.yingyong_type,
          item.Id,
          item.app_code,
          item.zuixin_pingjia_status,
          (data) => {
            console.log(data)
            if (data.ret == 1) {
              getCommentInfoMethod(0, commentList.length, 0);
              props.refreshMethod()
            } else {
              message.error(data.msg)
            }
          },
        )
      },
      onCancel() {
        console.log('用户点击了取消')
      },
    })
  }

  return (
    <div
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
      }}
    >
      <Drawer onClose={props.close} open={props.drawerStatus}>
        <div className={styles.topContainer}>
          <img className={styles.iconImg} src={props.info.icon_url} />
          <div className={styles.rightDiv}>
            <div className={styles.rightTitle}>{props.info.title}</div>
            <div className={styles.rightContent}>
              <div className={styles.commentTag}>综合评价</div>
              <Rate
                value={zhonghepingjia / 20}
                allowHalf
                disabled
                character={<HeartFilled />}
              />
            </div>
          </div>
        </div>
        <Divider style={{ borderColor: '#e7e9ec' }}></Divider>
        <h3>应用评分</h3>
        {zhibiaoList.map((item, index) => {
          return (
            <div className={styles.standardDiv}>
              <text>{item.zhibiao}</text>
              <Rate
                value={item.fenshu / 20}
                character={<HeartFilled />}
                style={{ marginLeft: 12 }}
                allowHalf
                onChange={(e) => {
                  console.log(e * 20)
                  let tempList = zhibiaoList.map((item1, index1) => {
                    if (index == index1) {
                      return {
                        zhibiao: item1.zhibiao,
                        fenshu: e * 20,
                      }
                    } else {
                      return item1
                    }
                  })
                  setZhibiaoList(tempList)
                }}
              />
            </div>
          )
        })}
        <ConfigProvider
          locale={locale}
          theme={{
            components: {
              Input: {
                colorPrimary: '#F5B544',
                colorBorder: '#F5B544',
                fontSize: 20,
                hoverBorderColor: '#F5B544',
              },
            },
          }}
        >
          <Space style={{ width: '100%' }}>
            <Input
              suffix={<CommentOutlined style={{ color: '#F5B544' }} />}
              style={{ borderRadius: 8 }}
              size={'large'}
              value={comment}
              onChange={(e) => {
                console.log(e)
                setComment(e.target.value)
              }}
            />
            <Button
              type="primary"
              style={{ borderRadius: 20, height: 40 }}
              onClick={sendCommentMethod}
            >
              <PlusOutlined size={'large'} />
              发送
            </Button>
          </Space>
        </ConfigProvider>
        <Divider style={{ borderColor: '#e7e9ec' }}></Divider>
        <Space style={{ marginBottom: 20 }}>
          <div>最新评论</div>
          <CommentOutlined />
        </Space>
        {commentList.map((item, index) => {
          return <CommentItem info={item} deleteComment={deleteCommentMethod} />
        })}
        <div
          style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}
        >
          {commentNumber > commentList.length ? (
            <div
              style={{ cursor: 'pointer' }}
              onClick={getCommentInfoMethod.bind(
                null,
                commentList.length,
                10,
                1
              )}
            >
              查看更多 &gt;&gt;
            </div>
          ) : (
            <div></div>
          )}
        </div>
      </Drawer>
    </div>
  )
}
